import { Col, Container, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { MyOrdersApprovalTable } from "common/components/MyOrdersApprovalTable";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { StringHelper } from "common/helpers";
import { Paths } from "common/paths/paths";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export const OrdersApprovalPage: FC = () => {
  const singleOrderApprovalPage = StringHelper.pathToRegex(Paths.approval.url).test(location.pathname);

  return (
    <PageMainContainer>
      <Container isFullWidth={false}>
        <Col gridGap="S200" width={"100%"}>
          <Row padding="S300" gridGap="S400" width={"100%"}>
            <Text fontSize="T400" color="neutral90" data-cy="approvals-page-title">
              {singleOrderApprovalPage
                ? getString("myOrdersApproval.singleOrderApproval.title")
                : getString("myOrdersApproval.title")}
            </Text>
          </Row>
          <Row padding="S300" gridGap="S400" width={"100%"}>
            <Col gridGap="S200" width={"100%"}>
              <MyOrdersApprovalTable />
            </Col>
          </Row>
        </Col>
      </Container>
    </PageMainContainer>
  );
};
